import { render } from "./Cadastradores.vue?vue&type=template&id=eb068910&scoped=true"
import script from "./Cadastradores.vue?vue&type=script&lang=js"
export * from "./Cadastradores.vue?vue&type=script&lang=js"

import "@siop/standard-libui/dist/css/bootstrap-4/siop.css?vue&type=style&index=0&id=eb068910&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb068910"]])

export default __exports__